<div *ngIf="tree" class="proc-selection-tree">
  <div *ngFor="let procTypeNode of tree.children" class="proc-selection-tree__node">
    <div class="proc-selection-tree__node-header">
      <mat-checkbox [checked]="isNodeSelected(procTypeNode)" [indeterminate]="isNodeIndeterminate(procTypeNode)"
                    (change)="onNodeChanged(procTypeNode, $event)"
                    class="proc-selection-tree__node-label" disableRipple>
        <button [disabled]="!procTypeNode.children || procTypeNode.children.length < 1" type="button" mat-icon-button
                (click)="toggleNodeExpanded(procTypeNode, $event)">
          <mat-icon *ngIf="procTypeNode.expanded">keyboard_arrow_down</mat-icon>
          <mat-icon *ngIf="!procTypeNode.expanded">keyboard_arrow_right</mat-icon>
        </button>
        <span class="proc-selection-tree__label proc-selection-tree__label--proc-type">{{ procTypeNode.label }}</span>
        <span class="proc-selection-tree__count">{{ procTypeNode.selectedDocs }}</span>
      </mat-checkbox>
      <div class="proc-selection-tree__node-size">
        <span class="proc-selection-tree__node-size-label">{{ formatSize(procTypeNode) }}</span>
      </div>
    </div>
    <div [@nodeExpansion]="procTypeNode.expanded ? 'expanded' : 'collapsed'" class="proc-selection-tree__node-children">
      <div *ngFor="let airportNode of procTypeNode.children" class="proc-selection-tree__node">
        <div *ngVar="airportNode.data as airport" class="proc-selection-tree__node-header">
          <mat-checkbox [checked]="isNodeSelected(airportNode)" [indeterminate]="isNodeIndeterminate(airportNode)"
                        (change)="onNodeChanged(airportNode, $event)"
                        class="proc-selection-tree__node-label" disableRipple>
            <button *ngIf="!airportNode.leaf" [disabled]="!airportNode.children || airportNode.children.length < 1"
                    type="button" mat-icon-button (click)="toggleNodeExpanded(airportNode, $event)">
              <mat-icon *ngIf="airportNode.expanded">keyboard_arrow_down</mat-icon>
              <mat-icon *ngIf="!airportNode.expanded">keyboard_arrow_right</mat-icon>
            </button>
            <span class="proc-selection-tree__label">{{airportNode.label }}</span>
            <span *ngIf="!airportNode.leaf" class="proc-selection-tree__count">{{ airportNode.selectedDocs }}</span>
          </mat-checkbox>
          <div class="proc-selection-tree__node-size">
            <span class="proc-selection-tree__node-size-label">{{ formatSize(airportNode) }}</span>
          </div>
        </div>
        <div [@nodeExpansion]="airportNode.expanded ? 'expanded' : 'collapsed'" class="proc-selection-tree__node-children">
          <div *ngFor="let procNode of airportNode.children" class="proc-selection-tree__node">
            <div *ngVar="procNode.data as procedure" class="proc-selection-tree__node-header">
              <mat-checkbox [checked]="isNodeSelected(procNode)" [indeterminate]="isNodeIndeterminate(procNode)"
                            (change)="onNodeChanged(procNode, $event)"
                            class="proc-selection-tree__node-label" disableRipple>
                <span class="proc-selection-tree__label">{{ procNode.label }}</span>
              </mat-checkbox>
              <div class="proc-selection-tree__node-size">
                <span class="proc-selection-tree__node-size-label">{{ formatSize(procNode) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
